/** @format */

import jwt_decode from 'jwt-decode';

export const TELECMI_OUTBOUND_CALL_STARTED = 'telecmi-outbound-call-started';
export const TELECMI_OUTBOUND_CALL_FAILED = 'telecmi-outbound-call-failed';

function guessOutboundCallerIdFromToken() {
  try {
    const t = localStorage.getItem('token');
    if (!t) return null;
    const d = jwt_decode(t);
    const v =
      d?.telecmi_caller_id ??
      d?.telecmiCallerId ??
      d?.telecmi_callerid ??
      d?.telecmi_default_callerid ??
      d?.telecmiDefaultCallerid ??
      null;
    if (v != null && String(v).trim() !== '') {
      return String(v).trim();
    }
  } catch {
    /* ignore */
  }
  return null;
}

/**
 * Fired when the user starts an outbound TeleCMI call (before API returns).
 * Main layout opens the live dialer with status "connecting".
 * @param {{ to?: string|number, from?: string|null, silent?: boolean }} payload
 */
export function emitTelecmiOutboundWaiting(payload = {}) {
  const { to, from, silent } = payload;
  if (silent) return;
  const resolvedFrom =
    from != null && String(from).trim() !== ''
      ? String(from).trim()
      : guessOutboundCallerIdFromToken();
  const toStr = to != null ? String(to) : '';
  window.dispatchEvent(
    new CustomEvent(TELECMI_OUTBOUND_CALL_STARTED, {
      detail: {
        from: resolvedFrom,
        to: toStr,
      },
    })
  );
}

/**
 * Fired when initiate API fails after a connecting state was shown.
 * @param {{ message?: string, to?: string|number, from?: string|null, silent?: boolean }} payload
 */
export function emitTelecmiOutboundFailed(payload = {}) {
  const { message, to, from, silent } = payload;
  if (silent) return;
  const resolvedFrom =
    from != null && String(from).trim() !== ''
      ? String(from).trim()
      : guessOutboundCallerIdFromToken();
  window.dispatchEvent(
    new CustomEvent(TELECMI_OUTBOUND_CALL_FAILED, {
      detail: {
        message: message != null ? String(message) : 'Call failed.',
        to: to != null ? String(to) : '',
        from: resolvedFrom,
      },
    })
  );
}
